// import util from '../../common/util';
export default {
    data: function() {
        return {
            slice1: 0,
            slice2: 0,
            gap: 0, //delete、
            menuWidthMap: {}
        };
    },
    created() {
        this.setDefaultSlice();
        // this._debouncedSizeChange = util.debounce(this.sizeChange, 100);
    },
    mounted() {
        this.$nextTick(() => {
            this.getCache();
            this.calculateSlice();
        });
    },
    methods: {
        headerResize() {
            this.sizeChange();
            // this._debouncedSizeChange();
        },
        setDefaultSlice() {
            this.slice1 = Math.ceil(this.menus.length / 2);
            this.slice2 = this.menus.length;
        },
        getCache() {
            if (!this.isMobileSize) {
                [
                    ...this.$el.querySelectorAll(
                        '.left-menu>.menu-item, .right-menu>.menu-item'
                    )
                ].forEach((menu, idx) => {
                    let marginRight = parseInt(
                        getComputedStyle(menu).marginRight
                    );
                    this.menuWidthMap[this.menus[idx] && this.menus[idx].name] =
                        menu.offsetWidth + marginRight;
                });
                this.menuWidthMap.font = this.navFont;
                // console.log('this.menuWidthMap ===>>', this.menuWidthMap);
            }
        },
        calculateSlice() {
            if (!Object.keys(this.menuWidthMap).length) {
                return;
            }
            if (this.menuWidthMap.font != this.navFont) {
                //main menu text style change, need to refresh cache
                this.setDefaultSlice();
                this.$nextTick(() => {
                    this.getCache();
                    this.calculateSlice();
                });
                return;
            }

            let nav = this.$el.querySelector('.header-bg');
            let logo = this.$el.querySelector('.logo-menu');
            let account = this.$el.querySelector('.head-account');
            let more = this.$el.querySelector('.right-menu>.more');
            let languages = this.$el.querySelectorAll(
                '.right-menu>.head-language-pc'
            );

            let moreWidth = more ? more.offsetWidth : 0;
            let lanWidth = [...languages].reduce((pre, dom) => {
                return pre + (dom.offsetWidth || 0);
            }, 0);
            // console.log('language width is ', lanWidth);

            let leftWidth = nav.offsetWidth / 2 - logo.offsetWidth / 2 - 50;
            let rightWidth =
                leftWidth - account.offsetWidth - moreWidth - lanWidth;

            let { slice1, slice2 } = this.narrowSituationCalc(
                leftWidth,
                rightWidth
            );
            //console.log("=======",slice1,slice2,this.menus.length,leftWidth,rightWidth);
            if (slice2 < this.menus.length) {
                this.slice1 = slice1;
                this.slice2 = slice2;
            } else {
                this.slice2 = this.menus.length;
                this.slice1 = this.wideSituationCalc(leftWidth, rightWidth);
            }
        },
        wideSituationCalc(leftWidth, rightWidth) {
            let left = 0,
                right = this.menus.length - 1;
            while (left < right + 1) {
                if (leftWidth > rightWidth) {
                    leftWidth -= this.menuWidthMap[this.menus[left++].name];
                } else {
                    rightWidth -= this.menuWidthMap[this.menus[right--].name];
                }
            }
            return left;
        },
        narrowSituationCalc(leftWidth, rightWidth) {
            function findEnd(arr, start, width) {
                if (start >= arr.length) {
                    return arr.length;
                }
                let sum = 0,
                    i = start,
                    len = arr.length;
                let menu;
                for (; i < len; i++) {
                    menu = arr[i];
                    sum += this.menuWidthMap[menu.name] || 0;
                    if (sum > width) {
                        break;
                    }
                }
                return i;
            }
            let slice1 = findEnd.call(this, this.menus, 0, leftWidth);
            let slice2 = findEnd.call(this, this.menus, slice1, rightWidth);
            return { slice1, slice2 };
        }
    },
    computed: {
        leftMenu() {
            return this.isMobileSize
                ? []
                : this.menus.slice(0, this.slice1);
        },
        rightMenu() {
            return this.isMobileSize
                ? this.menus
                : this.menus.slice(this.slice1, this.slice2);
        },
        moreMenu() {
            return this.isMobileSize
                ? []
                : this.menus.slice(this.slice2);
        },
        navFont() {
            return [
                this.mainMenuText.fontFamily,
                this.mainMenuText.fontSize
            ].join();
        }
    }
};
